import type { LocationQueryValue } from 'vue-router'

import constants from '~/constants'
import helpers from '~/helpers'

export function useUtm () {
  const route = useRoute()
  const router = useRouter()

  function clearCookie (name: string): void {
    const cookie = useCookie(name)

    if (cookie.value) {
      cookie.value = null
    }
  }

  async function deleteUtmParameters (): Promise<void> {
    const query = { ...route.query }

    let needToReplaceQuery = false

    const paramsToDelete = [
      'admitad_uid',
      'click_id',
      'utm_campaign',
      'utm_content',
      'utm_medium',
      'utm_source',
      'utm_term'
    ]

    for (const x of paramsToDelete) {
      if (Object.prototype.hasOwnProperty.call(query, x)) {
        delete query[x]

        if (!needToReplaceQuery) {
          needToReplaceQuery = true
        }
      }
    }

    if (needToReplaceQuery) {
      await router.replace({ query })
    }
  }

  function handleAdmitadSource (admitadUid: LocationQueryValue | LocationQueryValue[]): void {
    if (typeof admitadUid === 'string' && admitadUid !== '') {
      const cookieOptions = { maxAge: 7776000, path: '/' } // 7776000 seconds is 90 days.
      useCookie('admitad_uid', cookieOptions).value = admitadUid
    }

    clearCookie('cityads_click_id')
  }

  function handleCityAdsSource (cityAdsClickId: LocationQueryValue | LocationQueryValue[]): void {
    if (typeof cityAdsClickId === 'string' && cityAdsClickId !== '') {
      const cookieOptions = { maxAge: 2592000, path: '/' } // 2592000 seconds is 30 days.
      useCookie('cityads_click_id', cookieOptions).value = cityAdsClickId
    }

    clearCookie('admitad_uid')
  }

  async function parseUtmParameters (): Promise<void> {
    const query = { ...route.query }
    const {
      admitad_uid: admitadUid,
      click_id: cityAdsClickId,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_medium: utmMedium,
      utm_source: utmSource,
      utm_term: utmTerm
    } = query

    const utmParameters = helpers.purifyUtmParameters({ utmCampaign, utmContent, utmMedium, utmSource, utmTerm })

    if (utmParameters !== null && constants.paidUtmSources.includes(utmSource as string)) {
      localStorage.setItem('utmParameters', JSON.stringify(utmParameters))
    }

    if (utmSource === 'admitad') {
      handleAdmitadSource(admitadUid)
    } else if (utmSource === 'cityads') {
      handleCityAdsSource(cityAdsClickId )
    } else if (constants.paidUtmSources.includes(utmSource as string)) {
      clearCookie('admitad_uid')
      clearCookie('cityads_click_id')
    }
  }

  return { deleteUtmParameters, parseUtmParameters }
}
